import * as React from 'react';
import { GroupBuilder } from '../Group/GroupBuilder';
import { GroupContainer } from '../Group/GroupContainer';
import { Direction, sortByProperty } from '../Helpers/SortHelper';
import { Candidate } from '../Model/Candidate';
import { Industry } from '../Model/Industry';
import { StaticSettings } from '../StaticSettings';
import { GroupHeader } from './Candidate/GroupHeader';
import { GroupItem } from './Candidate/GroupItem';
import { GroupComponent } from './GroupComponent';
import { ListProps } from './ListProps';
import { Trans } from './Trans';

export class CandidateList extends React.Component<ListProps<Candidate>> {
    public render() {
        const props = this.props;
        const allModels = props.allModels;
        const filteredModels = props.filteredModels;
        if (allModels.length === 0) {
            return this.renderEmpty();
        }
        if (filteredModels.length === 0) {
            return this.renderNoResults();
        }

        const sortProperty = StaticSettings.ui.list.candidateSortBy;
        if (sortProperty !== undefined) {
            return this.renderWithFilteredModels(sortByProperty(filteredModels, sortProperty, Direction.Desc));
        } else {
            return this.renderWithFilteredModels(filteredModels);
        }
    }

    private renderWithFilteredModels(filteredModels: Candidate[]) {
        const groups = (new GroupBuilder()).groupByIndustry<Candidate>(filteredModels);

        return this.renderList(groups);
    }

    private renderList(groups: GroupContainer<Industry, Candidate>) {
        return <>
            {groups.map(
                group => <GroupComponent
                    key={group.key.referenceId}
                    group={group}
                    renderItem={m => <GroupItem model={m}/>}
                    renderHeader={() => <GroupHeader/>}
                />
            )}
        </>;
    }

    private renderEmpty() {
        return <h2><Trans>Im Moment sind keine Kandidaten vorhanden</Trans></h2>;
    }

    private renderNoResults() {
        return <h2><Trans>Es konnten keine Kandidaten entsprechend Ihrer Suche gefunden werden.</Trans></h2>;
    }
}
